// chakra imports
import { Box, Button, Flex, HStack, Icon, Stack, Text, useColorModeValue } from "@chakra-ui/react";
//   Custom components
import Brand from "components/sidebar/components/Brand";
import Links from "components/sidebar/components/Links";
import React from "react";
import { useGetAccountInfo } from "@multiversx/sdk-dapp/hooks/account";
import { logout } from '@multiversx/sdk-dapp/utils';
import { MdLogout } from "react-icons/md";
import { MOON_MISSION_ROUTE } from "routes";
import { Redirect } from "react-router-dom";




// FUNCTIONS

function SidebarContent(props) {
  const { routes } = props;
  const { address } = useGetAccountInfo();
  const isLoggedIn = Boolean(address);

  let textColor = useColorModeValue("secondaryGray.500", "white");

  const handleLogout = () => {
    logout(MOON_MISSION_ROUTE.path, (callbackurl) => {
      localStorage.removeItem("signature");
      return <Redirect to={callbackurl} />
    });
  };

  // SIDEBAR
  return (
    <Flex direction='column' height='100%' pt='25px' borderRadius='30px'>
      <Brand />
      <Stack height={'100%'} direction='column' mb='auto' mt='8px'>
        <Flex flexDirection={'column'} height='100%' ps='20px' pe='20px'>
          <Links routes={routes} />
          {isLoggedIn && (
            <Button ml={'auto'} mr='auto' mt={'auto'} mb='30px' className='btn-secondary btn-disconnect' onClick={handleLogout} cursor='pointer'>
              <HStack
                py='5px'
                ps='10px'>
                <Icon as={MdLogout} width='16px' height='16px' color='inherit' />

                <Flex w='100%' m={'0'} alignItems='flex-start' justifyContent='center'>
                  <Box
                    color={textColor}
                    me='18px'>
                  </Box>
                  <Text
                    me='auto'
                    color={textColor}
                    fontWeight={"normal"}>
                    Disconnect
                  </Text>
                </Flex>
              </HStack>
            </Button>
          )}
        </Flex>
      </Stack>
    </Flex>
  );
}

export default SidebarContent;
